<!-- eslint-disable -->
<template>
  <CommonPages id="name-detail" :class="['name-detail']" :title="pageTitle"
    :metaDescription="pageDescription">
    <div v-if="nameData.name">
      <div class="name-detail-row">
        <!-- 名字详情顶部区域 -->
        <div class="name-header" :class="[deviceType]">
          <div class="name-header-content">
            <div class="name-icon">
              <img v-if="genderIcon" :src="genderIcon" alt="gender icon" class="subtract-icon" />
            </div>
            <div class="name-title-container">
              <div class="name-title">{{ nameData.name }}</div>
              <div class="name-pronunciation">{{ nameData.pronunciation }}</div>
            </div>
          </div>
        </div>

        <!-- 名字信息卡片 -->
        <div class="name-info-card" :class="[deviceType]">
          <div class="info-row" v-if="deviceType !== 'mobile'">
            <div class="info-item">
              <div class="info-label">Gender</div>
              <div class="info-value">{{ nameData.gender }}</div>
            </div>
            <div class="info-divider"></div>
            <div class="info-item">
              <div class="info-label">US Popularity</div>
              <div class="info-value">{{ nameData.popularity }}</div>
            </div>
            <div class="info-divider"></div>
            <div class="info-item">
              <div class="info-label">Origin</div>
              <div class="info-value">{{ nameData.origin }}</div>
            </div>
            <div class="info-divider"></div>
            <div class="info-item">
              <div class="info-label">Style</div>
              <div class="info-value">{{ nameData.style }}</div>
            </div>
            <div class="info-divider"></div>
            <div class="info-item">
              <div class="info-label">Meaning</div>
              <div class="info-value">
                {{ nameData.meaningList ? nameData.meaningList.join(', ') : nameData.meaning }}
              </div>
            </div>
          </div>
          <div class="info-grid" v-else>
            <div class="info-grid-row">
              <div class="info-item">
                <div class="info-label">Gender</div>
                <div class="info-value">{{ nameData.gender }}</div>
              </div>
              <div class="info-divider vertical"></div>
              <div class="info-item">
                <div class="info-label">US Popularity</div>
                <div class="info-value">{{ nameData.popularity }}</div>
              </div>
            </div>
            <div class="info-divider horizontal"></div>
            <div class="info-grid-row">
              <div class="info-item">
                <div class="info-label">Origin</div>
                <div class="info-value">{{ nameData.origin }}</div>
              </div>
              <div class="info-divider vertical"></div>
              <div class="info-item">
                <div class="info-label">Style</div>
                <div class="info-value">{{ nameData.style }}</div>
              </div>
            </div>
            <div class="info-divider horizontal"></div>
            <div class="info-item full-width">
              <div class="info-label">Meaning</div>
              <div class="info-value">
                {{ nameData.meaningList ? nameData.meaningList.join(', ') : nameData.meaning }}
              </div>
            </div>
          </div>
          <div class="info-divider horizontal"></div>
          <div class="name-description">
            {{ nameData.description }}
          </div>
          <div class="info-divider horizontal"></div>
          <div v-if="nameData.nicknameList && nameData.nicknameList.length > 0">
            <div class="nicknames-section">
              <div class="nicknames-title">Common Nicknames for {{ nameData.name }}</div>
              <div class="nicknames-list">
                <div class="nickname-item" v-for="(nickname, index) in nameData.nicknameList"
                  :key="index">
                  <span>{{ nickname }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AdComponent :key="'ads-name-detail-1'"
        v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.name_detail_1"
        ref="ads-name-detail-1" class="ad-width-100 pc_padding m_padding"
        :ads="adsensConfig?.name_detail_1" :showDebug="showDebug" />

      <div class="similar-name-section" :class="[deviceType]" v-if="similarNames.length > 0">
        <!-- 相似名字标题区域 -->
        <div class="section-header" :class="[deviceType]">
          <div class="section-dot"></div>
          <div class="section-title">Similar Names</div>
        </div>

        <!-- 相似名字卡片区域 -->
        <div class="similar-names-list" :class="[deviceType]">
          <template v-for="(card, index) in similarNames">
            <router-link :key="index" :to="`/names/${card.name.toLowerCase()}/${card.id}`" tag="div"
              class="name-card-link">
              <div class="name-card" @mouseenter="hoveredCard = index"
                @mouseleave="hoveredCard = null">
                <div class="card-header">
                  <div class="card-name">{{ card.name }}</div>
                  <div class="card-gender-icon">
                    <img :src="card.genderIcon" alt="gender icon" />
                  </div>
                </div>
                <div class="card-pronunciation">{{ card.pronunciation }}</div>
                <div class="card-divider"></div>
                <div class="card-details" :class="[deviceType]">
                  <div class="card-detail">
                    <div class="detail-label">Style</div>
                    <div class="detail-value">{{ card.style }}</div>
                  </div>
                  <div class="card-detail">
                    <div class="detail-label">Meaning</div>
                    <!-- <div class="detail-value">{{ card.meaning }}</div> -->
                    <div class="detail-value">
                      <span v-for="(item, index) in card.meaningList" :key="item">
                        {{ item }}<template v-if="index < card.meaningList.length - 1">,</template>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="card-divider"></div>
                <div class="card-popularity">
                  <div class="popularity-label">US Popularity</div>
                  <div class="popularity-value">{{ card.popularity }}</div>
                </div>
              </div>
            </router-link>

            <!-- Mobile ad after 2nd card -->
            <AdComponent v-if="deviceType === 'mobile' && index === 1" :key="'ads-name-detail-2'"
              v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.name_detail_2"
              ref="ads-name-detail-2" class="ad-width-100 " :ads="adsensConfig?.name_detail_2"
              :showDebug="showDebug" />
            <!-- Mobile ad after 2nd card -->
            <AdComponent v-if="deviceType === 'mobile' && index === 3" :key="'ads-name-detail-3'"
              v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.name_detail_3"
              ref="ads-name-detail-3" class="ad-width-100 " :ads="adsensConfig?.name_detail_3"
              :showDebug="showDebug" />
          </template>
        </div>
      </div>

      <AdComponent v-if="deviceType != 'mobile' " :key="'ads-name-detail-2'"
        v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.name_detail_2"
        ref="ads-name-detail-2" class="ad-width-100 pc_padding" :ads="adsensConfig?.name_detail_2"
        :showDebug="showDebug" />

      <!-- 组合模块 -->
      <div class="combinations-section" :class="[deviceType]" v-if="combinations.length > 0">
        <div class="section-header">
          <div class="section-dot"></div>
          <div class="section-title">Combinations</div>
        </div>
        <div class="combinations-container">
          <div class="combination-row" :class="[deviceType]">
            <div class="combination-card" v-for="(combo, index) in combinations" :key="index"
              @click="navigateTo(combo.url)" @mouseenter="hoveredCombination = index"
              @mouseleave="hoveredCombination = null"
              :class="{'hovered': hoveredCombination === index}">
              <div class="combination-text">
                {{ combo.title }}
              </div>
              <div class="see-more-button">
                <span>See More</span>
                <img src="@/assets/default/arrow-right-small.svg" alt="arrow" class="arrow-icon" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <section class="search-sec-row" :class="[deviceType]">
        <!-- 搜索过滤区域 -->
        <div class="section-header" :class="[deviceType]">
          <div class="section-dot"></div>
          <div class="section-title">Search by Filter</div>
        </div>

        <div class="names-filter" :class="[deviceType]">
          <SearchFilter />
        </div>
      </section>
    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import SearchFilter from '@/components/SearchFilter.vue';
import AdComponent from '@/pages/components/AdComponent.vue'
import '@/css/common.scss';

export default {
  name: 'NameDetail',
  components: {
    CommonPages,
    SearchFilter,
    AdComponent,
  },
  mixins: [common, adMixin, adTrackingMixin],
  data () {
    return {
      hoveredCard: null,
      hoveredCombination: null,
      isGenerateHovered: false,
      isResetHovered: false,
      nameData: {},
      similarNames: [],
      combinations: [],
    };
  },
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      'showDebug',
      'deviceType',
      'domainConfig',
      'gender',
      'style',
      'meaning'
    ]),
    pageTitle () {
      const name = this.nameData?.name || '';
      return name ? `${name} - Meaning and Origin` : '';
    },
    pageDescription () {
      const name = this.nameData?.name || '';
      const origin = this.domainConfig?.origin || '';
      // eslint-disable-next-line max-len
      return name && origin ? `Discover the meaning, pronunciation, and cultural background of the ${origin} name ${name}.` : '';
    },
    genderIcon () {
      if (!this.nameData.gender) return null
      if (this.nameData.gender === 'Boy') {
        return require('@/assets/icons/male.png')
      } else if (this.nameData.gender === 'Unisex') {
        return require('@/assets/icons/unsex.png')
      } else {
        return require('@/assets/icons/female.png')
      }
    },
    genderOptions () {
      if (!this.gender || this.gender.length === 0) return [{ value: 'all', label: 'All' }];
      return [{ value: 'all', label: 'All' }, ...this.gender.map(item => ({ label: item, value: item }))];
    },
    styleOptions () {
      if (!this.style || this.style.length === 0) return [{ value: 'all', label: 'All' }];
      return [{ value: 'all', label: 'All' }, ...this.style.map(item => ({ label: item, value: item }))];
    },
    meaningOptions () {
      if (!this.meaning || this.meaning.length === 0) return [{ value: 'all', label: 'All' }];
      return [{ value: 'all', label: 'All' }, ...this.meaning.map(item => ({ label: item, value: item }))];
    },
  },
  methods: {
    resetFilters () {
      this.filters = JSON.parse(JSON.stringify(this.defaultFilters));
    },
    generateNames () {
      // 构建查询参数
      const queryParams = {};

      // 添加非默认值的过滤条件到查询参数
      Object.keys(this.filters).forEach(key => {
        if (this.filters[key] !== 'all') {
          queryParams[key] = this.filters[key];
        }
      });

      // 导航到名字列表页面，带上查询参数
      this.$router.push({
        path: '/names',
        query: queryParams
      });
    },
    async fetchNameDetail () {
      const { id } = this.$route.params;
      if (!id) return;
      try {
        const response = await this.$global.server.postAPI({
          method: 'get',
          params: { id },
          url: '/name/detail',
        });
        if (response.data) {
          this.nameData = response.data;
          this.fetchSimilarNames(this.nameData);
          this.fetchCombinations(this.nameData);
        }
      } catch (error) {
        console.error('Error fetching name detail:', error);
        this.nameData = {};
      }
    },
    async fetchSimilarNames (nameData) {
      if (!nameData.style) return;
      try {
        const params = {
          pageSize: '8',
          pageNum: '1',
          style: nameData.style,
          sortType: 'S_3'
        };
        if (this.domainConfig && this.domainConfig.origin) {
          params.origin = this.domainConfig.origin;
        }
        const response = await this.$global.server.postAPI({
          method: 'post',
          params,
          url: '/name/page',
        });
        if (response.data && response.data.list) {
          this.similarNames = response.data.list
            .filter(item => String(item.id) !== String(this.nameData.id))
            .map(item => ({
              id: item.id || '',
              name: item.name || 'N/A',
              genderIcon: item.gender === 'Boy'
                ? require('@/assets/icons/male.svg')
                : item.gender === 'Unisex'
                  ? require('@/assets/icons/unsex.svg')
                  : require('@/assets/icons/female.svg'),
              pronunciation: item.pronunciation || 'N/A',
              style: item.style || 'N/A',
              meaning: item.meaning || 'N/A',
              meaningList: item.meaningList || [],
              popularity: item.popularity || 'N/A'
            }));
        }
      } catch (error) {
        console.error('Error fetching similar names:', error);
      }
    },
    async fetchCombinations (nameData) {
      if (!nameData.origin) return;
      try {
        const params = { origin: nameData.origin };
        if (nameData.gender) {
          params.gender = nameData.gender;
        }
        const response = await this.$global.server.postAPI({
          method: 'get',
          params,
          url: '/name/combinations',
        });
        if (response.data && response.data.combinations) {
          this.combinations = response.data.combinations.slice(0, 4);
        }
      } catch (error) {
        console.error('Error fetching combinations:', error);
      }
    },
    navigateTo (url) {
      if (url) {
        this.$router.push(url);
      }
    }
  },
  async mounted () {
    this.fetchNameDetail();
    await this.initAdSystem();
    // 确保在广告系统初始化后再初始化跟踪
    this.$nextTick(() => {
      this.initAdTracking();
    });
  }
};
</script>

<style lang="scss" >
@import '~@/css/variables.scss';
.el-select-dropdown__list {
	padding: rem(3) 0;
}
.el-select-dropdown__item {
	padding: 0 rem(3) !important;
}
.el-select-dropdown__item.selected {
	color: #a31984;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
	background: rgba(163, 25, 132, 0.1);
}
.el-form {
	padding-bottom: 0;
}
.el-input__inner {
	border-radius: rem(20);
	border: rem(2) solid rgba(163, 25, 132, 0.1);
	background: #fff;
}
.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input.is-focus .el-input__inner {
	border-color: #a31984;
}
.el-input__inner:hover {
	border-color: rgba(163, 25, 132, 0.3);
}
.el-select:hover .el-input__inner {
	border-color: rgba(163, 25, 132, 0.3);
}
.el-select .el-input__inner:focus {
	border-color: #a31984;
}

.detect_deviece_mobile {
	.el-select-dropdown__item {
		font-size: rem(13);
		line-height: rem(34);
		height: rem(34);
	}
	.el-input__inner {
		height: rem(60);
		padding: rem(18) rem(44) rem(18) rem(24);
		border-radius: rem(20);
		border: rem(2) solid rgba(163, 25, 132, 0.1);
		background: #fff;
		color: #03133a;
		font-size: rem(18);
		font-style: normal;
		font-weight: 700;
		line-height: rem(20); /* 111.111% */
		text-transform: capitalize;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		display: inline-block;
	}
	.el-input__suffix {
		right: rem(24);
	}
	.el-select__caret {
		display: flex !important;
		align-items: center !important;
		justify-content: center !important;
	}
	.sort-select {
		.el-input__inner {
			border: none !important;
			border-radius: 0;
			color: #a31984;
			font-size: rem(16);
			font-style: normal;
			font-weight: 700;
			height: rem(16); /* 100% */
			line-height: rem(16); /* 100% */
			text-transform: capitalize;
		}
		.el-input__suffix {
			right: rem(8);
		}
		.el-select__caret {
			font-size: rem(16);
		}
	}
}
</style>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.name-detail {
	.name-detail-row {
		background: linear-gradient(180deg, rgba(163, 25, 132, 1) 0%, rgba(163, 25, 132, 0) 100%);
	}
	// 名字详情顶部区域样式
	.name-header {
		padding: rem(52) rem(180) rem(32);
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;

		.name-header-content {
			display: flex;
			flex-direction: row;
			gap: rem(8);
			align-items: flex-start;
			justify-content: flex-start;
			position: relative;

			.name-icon {
				padding: rem(8) 0;
				display: flex;
				align-items: center;
				justify-content: center;
				position: relative;

				.subtract-icon {
					width: rem(20);
					height: rem(20);
					position: relative;
				}
			}

			.name-title-container {
				display: flex;
				flex-direction: column;
				gap: rem(8);
				align-items: flex-start;
				justify-content: flex-start;
				position: relative;

				.name-title {
					color: #ffffff;
					text-align: left;
					font-size: rem(52);
					line-height: rem(52);
					font-weight: 900;
					position: relative;
					-webkit-text-stroke: rem(1) #ffffff;
					background: linear-gradient(108.74deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0.8) 30%, rgba(255, 255, 255, 1) 100%);
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
					background-clip: text;
				}

				.name-pronunciation {
					color: #ffffff;
					text-align: left;
					font-size: rem(16);
					line-height: rem(16);
					font-weight: 400;
					font-style: italic;
					position: relative;
				}
			}
		}

		&.mobile {
			padding: rem(32) rem(16) rem(32);

			.name-header-content {
				.name-title-container {
					.name-title {
						font-size: rem(36);
						line-height: rem(36);
					}
				}
			}
		}
	}

	// 名字信息卡片样式
	.name-info-card {
		padding: 0 rem(180) rem(32);
		display: flex;
		flex-direction: column;
		gap: rem(20);
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;

		background: linear-gradient(139.77deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.9) 59.95%, rgba(255, 255, 255, 0.6) 100%);
		border-radius: rem(36);
		border: rem(2) solid #ffffff;
		box-shadow: 0 rem(2) rem(4) 0 rgba(0, 0, 0, 0.08);
		padding: rem(32);
		margin: 0 rem(180) rem(32);

		.info-row {
			display: flex;
			flex-direction: row;
			gap: rem(32);
			align-items: center;
			justify-content: flex-start;
			position: relative;

			.info-item {
				display: flex;
				flex-direction: column;
				gap: rem(12);
				align-items: flex-start;
				justify-content: flex-start;
				position: relative;

				.info-label {
					color: #a31984;
					text-align: left;
					font-size: rem(12);
					line-height: rem(12);
					font-weight: 400;
					position: relative;
				}

				.info-value {
					color: #03133a;
					text-align: left;
					font-size: rem(16);
					line-height: rem(16);
					font-weight: 400;
					position: relative;
				}
			}

			.info-divider {
				border-left: rem(1) dashed rgba(163, 25, 132, 0.2);
				height: rem(40);
				width: rem(1);
				position: relative;
			}
		}

		.info-grid {
			display: flex;
			flex-direction: column;
			gap: rem(12);
			width: 100%;

			.info-grid-row {
				display: flex;
				justify-content: space-between;

				.info-item {
					width: calc(50% - rem(8));
				}
			}

			.info-item {
				&.full-width {
					width: 100%;
				}
			}

			.info-divider.vertical {
				border-left: rem(1) dashed rgba(163, 25, 132, 0.2);
				height: rem(40);
			}
		}

		.info-divider.horizontal {
			border-top: rem(1) dashed rgba(163, 25, 132, 0.2);
			width: 100%;
			height: rem(1);
			position: relative;
		}

		.name-description {
			color: #374674;
			text-align: left;
			font-size: rem(12);
			line-height: rem(20);
			font-weight: 400;
			position: relative;
			align-self: stretch;
		}

		.nicknames-section {
			display: flex;
			flex-direction: column;
			gap: rem(16);
			align-items: flex-start;
			justify-content: flex-start;
			align-self: stretch;
			position: relative;

			.nicknames-title {
				color: #03133a;
				text-align: left;
				font-size: rem(16);
				line-height: rem(20);
				font-weight: 900;
				position: relative;
			}

			.nicknames-list {
				display: flex;
				flex-direction: row;
				gap: rem(16);
				align-items: center;
				justify-content: flex-start;
				flex-wrap: wrap;
				position: relative;

				.nickname-item {
					background: rgba(163, 25, 132, 0.1);
					border-radius: rem(100);
					padding: rem(8) rem(20);
					display: flex;
					align-items: center;
					justify-content: center;
					position: relative;
					cursor: pointer;

					&.active {
						background: #a31984;

						span {
							color: #ffffff;
						}
					}

					span {
						color: #a31984;
						text-align: left;
						font-size: rem(14);
						line-height: rem(14);
						font-weight: 600;
						position: relative;
					}
				}
			}
		}

		&.mobile {
			padding: rem(24);
			margin: 0 rem(16) rem(32);
			gap: rem(16);

			.info-item {
				display: flex;
				flex-direction: column;
				gap: rem(12);

				.info-label {
					color: #a31984;
					font-size: rem(12);
					line-height: rem(12);
					font-weight: 400;
				}

				.info-value {
					color: #03133a;
					font-size: rem(16);
					line-height: rem(16);
					font-weight: 400;
				}
			}

			.nicknames-list {
				gap: rem(12);
			}
		}
	}

	// 搜索过滤区域样式
	.search-sec-row {
		gap: rem(24);
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
	}
	.names-filter {
		padding: 0 rem(180);
		display: flex;
		flex-direction: column;
		gap: rem(10);
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		position: relative;

		.filter-container {
			background: #f7f3f3;
			border-radius: rem(36);
			padding: rem(32);
			display: flex;
			flex-direction: column;
			gap: rem(48);
			align-items: flex-start;
			justify-content: flex-start;
			width: 100%;
			position: relative;

			.filter-rows {
				display: flex;
				flex-direction: column;
				gap: rem(24);
				align-items: flex-start;
				justify-content: flex-start;
				width: 100%;
				position: relative;

				.filter-row {
					display: flex;
					flex-direction: row;
					gap: rem(28);
					align-items: center;
					justify-content: flex-start;
					align-self: stretch;
					position: relative;

					.filter-item {
						display: flex;
						flex-direction: column;
						gap: rem(8);
						align-items: flex-start;
						justify-content: flex-start;
						flex: 1;
						position: relative;

						&.opacity-0 {
							opacity: 0;
						}

						.filter-label {
							padding: 0 rem(20);
							color: #03133a;
							text-align: left;
							font-size: rem(16);
							line-height: rem(16);
							font-weight: 400;
							position: relative;
						}

						:deep(.filter-select) {
							width: 100%;
							border-radius: rem(20);

							.el-input__wrapper {
								background: #ffffff;
								border-radius: rem(20);
								border: rem(2) solid rgba(163, 25, 132, 0.1);
								padding: rem(18) rem(24);
								box-shadow: none !important;
								height: rem(60);
								transition: all 0.3s ease;
								cursor: pointer;

								&:hover {
									border-color: rgba(163, 25, 132, 0.3);
								}

								&.is-focus {
									border-color: #a31984;
								}

								.el-input__inner {
									color: #03133a;
									font-size: rem(18);
									line-height: rem(20);
									font-weight: 700;
									height: 100%;
									max-width: calc(100% - rem(20));
									white-space: nowrap;
									overflow: hidden;
									text-overflow: ellipsis;
								}
							}

							&.active .el-input__wrapper {
								border-color: #a31984;
							}

							.el-select__caret {
								color: #03133a;
								font-size: rem(18);
							}
						}
					}
				}
			}

			.filter-actions {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;
				align-self: stretch;
				position: relative;

				.generate-button {
					background: #a31984;
					border-radius: rem(100);
					padding: rem(20) rem(32);
					display: flex;
					flex-direction: row;
					gap: rem(16);
					align-items: center;
					justify-content: center;
					width: rem(320);
					height: rem(60);
					position: relative;
					cursor: pointer;
					transition: all 0.3s ease;

					&.hovered {
						opacity: 0.8;
					}

					.generate-icon {
						width: rem(28);
						height: rem(28);
					}

					span {
						color: #ffffff;
						text-align: center;
						font-size: rem(22);
						line-height: rem(24);
						font-weight: 900;
						position: relative;
					}
				}

				.reset-button {
					border-radius: rem(100);
					border: rem(1) solid #a31984;
					display: flex;
					flex-direction: row;
					gap: rem(16);
					align-items: center;
					justify-content: center;
					width: rem(160);
					height: rem(60);
					position: relative;
					cursor: pointer;
					transition: all 0.3s ease;

					&.hovered {
						background: #a31984;

						span {
							color: #ffffff;
						}

						.reset-icon {
							filter: brightness(0) invert(1);
						}
					}

					.reset-icon {
						width: rem(20);
						height: rem(20);
					}

					span {
						color: #a31984;
						text-align: left;
						font-size: rem(20);
						line-height: rem(20);
						font-weight: 700;
						position: relative;
					}
				}
			}
		}

		&.mobile {
			padding: 0 rem(16);

			.filter-container {
				padding: rem(32);
				gap: rem(32);

				.filter-rows {
					gap: rem(16);
				}

				.filter-actions {
					flex-direction: column;
					gap: rem(16);

					.generate-button,
					.reset-button {
						width: 100%;
						padding: rem(20) 0;
					}
				}
			}
		}
	}
	.filter-item {
		display: flex;
		flex-direction: column;
		gap: rem(8);
		align-items: flex-start;
		justify-content: flex-start;
		flex: 1;
		position: relative;

		&.opacity-0 {
			opacity: 0;
		}

		.filter-label {
			padding: 0 rem(20);
			color: #03133a;
			text-align: left;
			font-size: rem(16);
			line-height: rem(16);
			font-weight: 400;
			position: relative;
		}

		:deep(.filter-select) {
			width: 100%;
			border-radius: rem(20);

			.el-input__wrapper {
				background: #ffffff;
				border-radius: rem(20);
				border: rem(2) solid rgba(163, 25, 132, 0.1);
				padding: rem(18) rem(24);
				box-shadow: none !important;
				height: rem(60);
				transition: all 0.3s ease;
				cursor: pointer;

				&:hover {
					border-color: rgba(163, 25, 132, 0.3);
				}

				&.is-focus {
					border-color: #a31984;
				}

				.el-input__inner {
					color: #03133a;
					font-size: rem(18);
					line-height: rem(20);
					font-weight: 700;
					height: 100%;
					max-width: calc(100% - rem(20));
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}
			}

			&.active .el-input__wrapper {
				border-color: #a31984;
			}

			.el-select__caret {
				color: #03133a;
				font-size: rem(18);
			}
		}
	}
	.detect_deviece_mobile & {
		padding: rem(60) 0;

		.section-header {
			padding: 0 rem(16);
		}

		.names-filter {
			padding: 0 rem(16);

			.filter-container {
				padding: rem(32);
				gap: rem(32);

				.filter-rows {
					gap: rem(16);
				}

				.filter-actions {
					flex-direction: column;
					gap: rem(16);

					.generate-button,
					.reset-button {
						width: 100%;
						padding: rem(20) 0;
					}
				}
			}
		}

		.filter-item {
			width: 100%;
		}
		.el-select__caret {
			display: flex !important;
			align-items: center !important;
			justify-content: center !important;
		}
	}
	// 组合模块样式
	.combinations-section {
		padding: rem(32) 0;
		display: flex;
		flex-direction: column;
		gap: rem(32);
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
		margin-bottom: rem(32);

		.combinations-container {
			padding: 0 rem(180);
			display: flex;
			flex-direction: column;
			gap: rem(24);
			align-items: center;
			justify-content: space-between;
			align-self: stretch;
			position: relative;

			.combination-row {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;
				align-self: stretch;
				position: relative;
				flex-wrap: wrap;
				gap: rem(24);
				width: 100%;
				&.mobile {
					.combination-card {
						flex-direction: column;
						gap: rem(24);
						align-items: flex-end;
					}
				}
			}

			.combination-card {
				background: #f7f3f3;
				border-radius: rem(36);
				padding: rem(28) rem(32);
				display: flex;
				flex-direction: row;
				gap: rem(84);
				align-items: center;
				justify-content: flex-start;
				align-self: stretch;
				// flex: 1;
				flex: 0 0 calc((100% - rem(24)) / 2); /* 使每个子元素占1/3的宽度 */
				// width: calc(50% - rem(12));
				position: relative;
				transition: all 0.3s ease;
				cursor: pointer;

				&.active {
					background: #ffffff;
					border: rem(1) solid #a31984;

					.combination-text {
						color: #a31984;
						font-weight: 700;
					}
				}

				&:hover {
					background: #ffffff;
					border: rem(1) solid #a31984;

					.combination-text {
						color: #a31984;
						font-weight: 700;
					}
				}

				.combination-text {
					color: #03133a;
					text-align: left;
					font-size: rem(18);
					line-height: rem(28);
					font-weight: 400;
					position: relative;
					flex: 1;
				}

				.see-more-button {
					border-radius: rem(12);
					border: rem(1) solid #a31984;
					padding: rem(8) rem(16);
					display: flex;
					flex-direction: row;
					gap: rem(8);
					align-items: center;
					justify-content: flex-start;
					position: relative;
					transition: all 0.3s ease;
					cursor: pointer;

					&.active {
						background: #a31984;

						span {
							color: #ffffff;
						}
					}

					span {
						color: #a31984;
						text-align: center;
						font-size: rem(12);
						line-height: rem(12);
						font-weight: 700;
						position: relative;
					}

					.arrow-icon {
						width: rem(6);
						height: rem(10);
					}
				}
			}
		}

		&.mobile {
			.section-header {
				padding: 0 rem(16);
			}

			.combinations-container {
				padding: 0 rem(16);

				.combination-row {
					flex-direction: column;
					gap: rem(16);
				}

				.combination-card {
					width: 100%;
				}
			}
		}
	}
	// 标题区域样式
	.section-header {
		padding: 0 rem(180);
		display: flex;
		flex-direction: row;
		gap: rem(16);
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		position: relative;

		.section-dot {
			background: #a31984;
			border-radius: rem(100);
			width: rem(8);
			height: rem(4);
			position: relative;
		}

		.section-title {
			color: #03133a;
			text-align: left;
			font-size: rem(28);
			line-height: rem(28);
			font-weight: 900;
			position: relative;
		}

		&.mobile {
			padding: 0 rem(16);
		}
	}

	.similar-name-section {
		&.mobile {
			display: flex;
			flex-direction: column;
			gap: rem(24);

			padding-top: rem(32);
		}
	}

	// 相似名字卡片区域样式
	.similar-names-list {
		padding: rem(32) rem(180);
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: rem(24);
		align-items: start;
		justify-content: space-between;
		width: 100%;
		box-sizing: border-box;
		position: relative;

		.name-card {
			background: linear-gradient(101.3deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.6) 70%, rgba(255, 255, 255, 0) 100%);
			border-radius: rem(36);
			border: rem(1) solid rgba(3, 19, 58, 0.04);
			padding: rem(24);
			display: flex;
			flex-direction: column;
			gap: rem(16);
			align-items: flex-start;
			justify-content: flex-start;
			width: 100%;
			height: rem(274);
			position: relative;
			box-shadow: 0 rem(2) rem(4) 0 rgba(0, 0, 0, 0.08);
			transition: all 0.3s ease;
			cursor: pointer;
			box-sizing: border-box;

			&:hover {
				border-color: #a31984;
				box-shadow: none;
			}

			.card-header {
				display: flex;
				flex-direction: row;
				gap: rem(8);
				align-items: center;
				justify-content: flex-start;
				align-self: stretch;
				position: relative;

				.card-name {
					color: #03133a;
					text-align: left;
					font-size: rem(18);
					line-height: rem(20);
					font-weight: 900;
					position: relative;
				}

				.card-gender-icon {
					width: rem(16);
					height: rem(16);
					position: relative;

					img {
						width: 100%;
						height: 100%;
					}
				}
			}

			.card-pronunciation {
				background: #f7f3f3;
				border-radius: rem(8);
				padding: rem(4) rem(8);
				color: #03133a;
				text-align: left;
				font-size: rem(13);
				line-height: rem(14);
				font-weight: 400;
				font-style: italic;
				position: relative;
			}

			.card-divider {
				border-top: rem(1) dashed rgba(3, 19, 58, 0.1);
				align-self: stretch;
				height: 0;
				position: relative;
			}

			.card-details {
				display: flex;
				flex-direction: column;
				gap: rem(16);
				align-items: flex-start;
				justify-content: flex-start;
				align-self: stretch;
				position: relative;

				&.mobile {
					flex-direction: row;
					gap: rem(16);
					.card-detail {
						width: 50% !important;
					}
				}

				.card-detail {
					display: flex;
					flex-direction: column;
					gap: rem(8);
					align-items: flex-start;
					justify-content: flex-start;
					align-self: stretch;
					position: relative;

					.detail-label {
						color: #a31984;
						text-align: left;
						font-size: rem(12);
						line-height: rem(12);
						font-weight: 200;
						position: relative;
						align-self: stretch;
					}

					.detail-value {
						color: #03133a;
						text-align: left;
						font-size: rem(13);
						line-height: rem(14);
						font-weight: 700;
						position: relative;
						align-self: stretch;
						display: flex;
						gap: rem(7);
					}
				}
			}

			.card-popularity {
				border-radius: rem(8);
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;
				align-self: stretch;
				position: relative;

				.popularity-label {
					color: #a31984;
					text-align: left;
					font-size: rem(12);
					line-height: rem(12);
					font-weight: 200;
					position: relative;
				}

				.popularity-value {
					background: #a31984;
					border-radius: rem(8);
					padding: rem(4) rem(8);
					color: #ffffff;
					text-align: center;
					font-size: rem(14);
					line-height: rem(14);
					font-weight: 900;
					font-style: italic;
					height: rem(22);
					display: flex;
					align-items: center;
					justify-content: center;
				}
			}
		}

		&.mobile {
			padding: 0 rem(16);
			grid-template-columns: 1fr;
			gap: rem(16);
		}
	}
}
</style> 